import { FontPack } from '@/types/theme-packs.types';
import { TemplatesReducerCreator } from '../types';
import { PayloadAction } from '@reduxjs/toolkit';

const setFontPackReducer = (create: TemplatesReducerCreator) => {
  return create.reducer((state, action: PayloadAction<FontPack>) => {
    state.fontPacks = state.fontPacks?.map((fp) => {
      if (fp.font_pack === action.payload.font_pack) {
        return action.payload;
      }
      return fp;
    }) || [action.payload];
  });
};

export default setFontPackReducer;
